
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_30856_4545)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.017 9.013l.074-.101A5.416 5.416 0 005.716.3 5.416 5.416 0 00.3 5.717a5.416 5.416 0 008.611 4.375l.102-.075 3.475 3.478a.71.71 0 001.004-1.004l-3.475-3.478zm-2.77.397a3.998 3.998 0 11-3.06-7.387 3.998 3.998 0 013.06 7.387z","fill":"#58697D"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_30856_4545"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h14v14H0z"}})])])])
          )
        }
      }
    